module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Forest Ghost")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', [_vm._v("Recent Titles by Graham Masterton available from Severn House")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("The Sissy Sawyer Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("TOUCHY AND FEELY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("THE PAINTED MAN")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1-space-after"
  }, [_vm._v("THE RED HOTEL")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("The Jim Rook Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("ROOK")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("THE TERROR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("TOOTH AND CLAW")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("SNOWMAN")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("SWIMMER")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("DARKROOM")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("DEMON’S DOOR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1-space-after"
  }, [_vm._v("GARDEN OF EVIL")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("Anthologies")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("FACES OF FEAR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("FEELINGS OF FEAR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("FORTNIGHT OF FEAR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("FLIGHTS OF FEAR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1-space-after"
  }, [_vm._v("FESTIVAL OF FEAR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("Novels")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("BASILISK")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("BLIND PANIC")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("CHAOS THEORY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("COMMUNITY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("DESCENDANT")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("DOORKEEPERS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("EDGEWISE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("FIRE SPIRIT")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("FOREST GHOST")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("GENIUS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("GHOST MUSIC")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("THE HIDDEN WORLD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("HOLY TERROR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("HOUSE OF BONES")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("MANITOU BLOOD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("THE NINTH NIGHTMARE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("PETRIFIED")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("UNSPEAKABLE")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5f3fa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/alsoby.vue
// module id = 63
// module chunks = 0